import React from "react";

import { SaleStatusTag } from "./SaleStatusTag";

export function AvailabilityDate(props) {
  let date = new Date(props.result.AvailabilityDate);
  let productNotAvailable =
    props.result.SaleStatus === 0 ||
    props.result.SaleStatus === 3 ||
    props.result.StockStatus === 5 ||
    (props.result.StockStatus === 3 && props.result.SaleStatus === 1) ||
    (props.result.StockStatus === 1 &&
      props.result.AvailibilityList.length !== 0);
  return (
    <div className="availability-date-container">
      <div className="mini-card-stock">
        <div className="mini-card-stock-title">DISPO ENTREPOT</div>
        <div className="mini-card-date">
          {isNaN(date) || productNotAvailable
            ? "-/-/-"
            : date.toLocaleDateString()}
        </div>
      </div>
      <div className="tag-container">
        <SaleStatusTag result={props.result} />
      </div>
    </div>
  );
}
